import 'whatwg-fetch'
const env = process.env;

const getPlantContainerList = (data) => {
  return fetch(`${env.VUE_APP_trimaster}/api/v1/infrastructure/getPlantContainerList?access_token=${data.apitoken}&plantContainer_id=${data.plantContainer_id}&env=${env.VUE_APP_env}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  })
}

const getEmptyPlantContainer = (data) => {
  return fetch(`${env.VUE_APP_trimaster}/api/v1/infrastructure/getEmptyPlantContainer?access_token=${data.apitoken}&plantContainerType_id=${data.plantContainerType_id}&facility_id=${data.facility_id}&exclude=${data.exclude}&env=${env.VUE_APP_env}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  })
}

export default {
  getPlantContainerList,
  getEmptyPlantContainer,
}
